import { Col, Row } from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import { ReactComponent as NoTicketIcon } from 'app/assets/img/no-ticket-icon.svg';
import ContainerFluid from 'app/components/Layout/ContainerFluid';
import { StyledStack } from 'app/components/Stack';
import { Permission } from 'app/hooks/usePermission';
import _ from 'lodash';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { formatNumber } from 'utils/helper';
import { selectInfoUser, selectTranslations } from '../App/slice/selectors';
import TooltipParagraph from '../Catalog/tooltipParagraph';
import StyledSelect from '../NewAccount/components/StyledSelect';
import ParkRevenueReport from './components/ParkRevenueReport';
import { ReportCardTitle } from './components/reportChartUtils';
import { RevenueReportChart } from './components/RevenueReportChart';
import TicketTypeRevenueReport from './components/TicketTypeRevenueReport';
import TopProductReport from './components/TopProductReport';
import TopStaffReport from './components/TopStaffReport';
import { HomePageWrapper } from './styled';
import {
  getOverviewApi,
  getRevenueReportApi,
  getStatisticsApi,
} from 'app/services/homePageApi';
import useFetchData from 'app/hooks/useFetchData';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { useHasComboHolidayAccess } from './hooks/useHasComboHolidayAccess';
import OrderPendingSkeleton from './components/OrderPendingSkeleton';
import TicketExpireSoonSkeleton from './components/TicketExpireSoonSkeleton';
interface IPendingOrder {
  id: number;
  name: string;
  totalTicket: number;
  disabled: boolean;
  redirect: string;
  type: string;
}
interface IExpiringTicket {
  id: number;
  name: string;
  quantity: number;
  expiredAt: any;
  productCode: string;
  productName: string;
  remainingDays: string;
  type: string;
}
type YearOption = {
  label: string;
  value: number;
};

const getYearsFrom2024ToNow = (): YearOption[] => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: currentYear - 2024 + 1 }, (_, i) => {
    const year = currentYear - i;
    return {
      label: year.toString(),
      value: year,
    };
  });
};
export const HomePage: React.FC = () => {
  const userInfo = useSelector(selectInfoUser);
  const translations = useSelector(selectTranslations);
  const history = useHistory();
  const { isHasComboHolidayAccess } = useHasComboHolidayAccess();
  const now = new Date();
  const [dataPendingOrder, setDataPendingOrder] = useState<IPendingOrder[]>([
    {
      id: 1,
      name: translations?.['b2b.txt.parkTicketOrder'],
      totalTicket: 0,
      disabled: false,
      redirect: '/account',
      type: 'b2b',
    },
    {
      id: 2,
      name: translations?.['b2b.txt.holidayComboOrder'],
      totalTicket: 0,
      disabled: false,
      redirect: '/order-management',
      type: 'holiday',
    },
  ]);
  const [dataTicket, setDataTicket] = useState<IExpiringTicket[]>([]);
  const [revenueFilter, setRevenueFilter] = useState('month');
  const optionFilterStatistics = [
    { label: translations?.['b2b.txt.thisWeekRevenue'], value: 'week' },
    { label: translations?.['b2b.txt.thisMonthRevenue'], value: 'month' },
    { label: translations?.['b2b.txt.thisYearRevenue'], value: 'year' },
  ];
  const [dataFilterRevenue] = useState<YearOption[]>(getYearsFrom2024ToNow());
  const [yearFilter, setYearFilter] = useState(now.getFullYear());
  const isSaleMng =
    userInfo?.role_code === Permission.ROLE_SALE_MANAGER ||
    userInfo?.role_code === Permission.ROLE_SALE_SHG;
  const {
    result: dataStatistics,
    onFetchData: onFetchStatistics,
    isLoading: isLoadingStatistics,
  } = useFetchData({
    actionApi: getStatisticsApi,
    IIFE: false,
    payloadData: {
      filter: revenueFilter,
    },
  });
  const { onFetchData: onFetchDataOverview, isLoading: isLoadingOverview } =
    useFetchData({
      actionApi: getOverviewApi,
      IIFE: false,
      onSuccess: response => {
        const { pendingOrderCount, unusedTickets } = response;
        const dataPending = dataPendingOrder.map(el => {
          const ticketCount = pendingOrderCount[el.type] || 0;
          return {
            ...el,
            name: translations?.[
              el.id === 1
                ? 'b2b.txt.parkTicketOrder'
                : 'b2b.txt.holidayComboOrder'
            ],
            totalTicket: ticketCount,
            disabled:
              ticketCount === 0 || (el.id === 2 && !isHasComboHolidayAccess),
          };
        });
        setDataPendingOrder(dataPending);
        setDataTicket(unusedTickets?.top3 || []);
      },
    });
  const {
    result: revenueResult,
    onFetchData: onFetchRevenueReport,
    isLoading: isLoadingRevenueReport,
  } = useFetchData({
    actionApi: getRevenueReportApi,
    IIFE: false,
    payloadData: {
      year: yearFilter,
    },
  });
  useEffect(() => {
    if (translations) {
      onFetchDataOverview();
      onFetchStatistics();
      onFetchRevenueReport();
    }
  }, [translations]);
  const onClickSeeAllTicket = () => {
    history.push('/check-tickets');
  };
  const onClickSeeAllOrder = (pathname: string) => {
    history.push(pathname);
  };

  const onClickPaymentNow = (item: IPendingOrder) => {};
  const onChangeFilterStatistics = val => {
    setRevenueFilter(val);
    onFetchStatistics({ payloadData: { filter: val } });
  };
  const onChangeYearFilter = val => {
    setYearFilter(val);
    onFetchRevenueReport({ payloadData: { year: val } });
  };
  return (
    <ContainerFluid>
      <HomePageWrapper>
        <div className="title">{translations?.['b2b.txt.overviewReport']}</div>
        <Row gutter={[16, 16]}>
          <Col md={24} lg={12} style={{ width: '100%' }}>
            <div className="box-left-overview">
              <div className="d-flex">
                <div className="sub-title">
                  {translations?.['b2b.txt.pendingPaymentOrders']}{' '}
                </div>
              </div>
              {isLoadingOverview || !translations ? (
                <OrderPendingSkeleton />
              ) : (
                dataPendingOrder?.map(item => {
                  return (
                    <div
                      key={item.id}
                      className="box-item pt-4 pb-4"
                      onClick={() => onClickPaymentNow(item)}
                    >
                      <TooltipParagraph className="item-title w-100 mb-0">
                        {item.name} <strong>({item.totalTicket})</strong>
                      </TooltipParagraph>
                      <ButtonSeeAll
                        onClick={() => onClickSeeAllOrder(item.redirect)}
                        disabled={
                          !item.totalTicket ||
                          (item.id === 2 && !isHasComboHolidayAccess)
                        }
                      >
                        {translations?.['b2b.txt.viewAll']}
                        <i className="fa fa-angle-right"></i>
                      </ButtonSeeAll>
                    </div>
                  );
                })
              )}
            </div>
          </Col>
          <Col md={24} lg={12} style={{ width: '100%' }}>
            <div className="box-right-overview">
              <div className="d-flex">
                <div className="sub-title">
                  {translations?.['b2b.txt.expiringSoonTotalTicket']}
                </div>
                <div className="see-all" onClick={onClickSeeAllTicket}>
                  {translations?.['b2b.txt.viewAll']}
                  <i className="fa fa-angle-right"></i>
                </div>
              </div>
              {isLoadingOverview || !translations ? (
                <TicketExpireSoonSkeleton />
              ) : (
                <>
                  {!_.isEmpty(dataTicket) ? (
                    dataTicket.map((item, index) => (
                      <div
                        key={`${item?.productCode || index}_${index}`}
                        className="box-item"
                      >
                        <div style={{ width: '100%' }}>
                          <div style={{ maxWidth: '90%' }}>
                            <TooltipParagraph className="item-title">
                              {item?.productName}
                            </TooltipParagraph>
                          </div>
                          <div className="d-flex gap-4">
                            <div className="item-sub-title">
                              {translations?.['b2b.cart.totalTickets']}:{' '}
                              <strong style={{ color: 'var(--color-11)' }}>
                                {item?.quantity}
                              </strong>
                            </div>
                            <div className="item-sub-title-date">
                              {translations?.['b2b.txt.expired-time']}{' '}
                              {moment(
                                item?.expiredAt?.datetimeDMYHIS ?? undefined,
                                'HH:mm:ss DD/MM/YYYY',
                              ).format('DD/MM/YYYY')}
                            </div>
                          </div>
                        </div>
                        <div className="item-tag">
                          {translations?.['b2b.txt.remainingDays']?.replace(
                            '${n}',
                            item.remainingDays,
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="box-no-order">
                      <NoTicketIcon />
                      {translations?.['b2b.txt.noExpiringTickets']}
                    </div>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
        {/* data overview */}
        <div className="box-data-overview">
          <StyledStack
            justifyContent={'space-between'}
            style={{ marginBottom: 20 }}
          >
            <ReportCardTitle>
              <div className="title">
                {translations?.['b2b.txt.statisticsOverview']}
              </div>
              <div className="report-card-note">
                {translations?.['b2b.txt.successfulTicketNote'] ?? ''}
              </div>
            </ReportCardTitle>
            <StyledSelect
              suffixIcon={<ArrowDownIcon />}
              value={revenueFilter}
              onChange={onChangeFilterStatistics}
              options={optionFilterStatistics}
            />
          </StyledStack>
          <Row gutter={[16, 16]}>
            <Col xs={24} md={24} lg={isSaleMng ? 6 : 8}>
              <div className="box-item-data">
                <div className="text-title-data">
                  {translations?.['b2b.txt.total']}{' '}
                  {String(
                    optionFilterStatistics.find(
                      el => el.value === revenueFilter,
                    )?.label || '',
                  ).toLowerCase()}
                </div>
                <div className="text-num-data">
                  {isLoadingStatistics
                    ? translations?.['b2b.txt.loadingData']
                    : _.isNil(dataStatistics?.filterRevenue?.total?.revenue)
                    ? 'N/A'
                    : `${formatNumber(
                        dataStatistics?.filterRevenue?.total?.revenue,
                        '.',
                      )}đ`}
                </div>
              </div>
            </Col>
            <Col xs={24} md={24} lg={isSaleMng ? 6 : 8}>
              <div className="box-item-data">
                <div className="text-title-data">
                  {translations?.['b2b.txt.totalTicketRevenue']}
                </div>
                <div className="text-num-data">
                  {isLoadingStatistics
                    ? translations?.['b2b.txt.loadingData']
                    : _.isNil(dataStatistics?.filterRevenue?.sw?.revenue)
                    ? 'N/A'
                    : `${formatNumber(
                        dataStatistics?.filterRevenue?.sw?.revenue,
                        '.',
                      )}đ`}
                </div>
                <div className="text-title-data">
                  {translations?.['b2b.txt.totalTicketOrdersSW']}
                </div>
                <div className="text-num-data">
                  {isLoadingStatistics
                    ? translations?.['b2b.txt.loadingData']
                    : _.isNil(dataStatistics?.filterRevenue?.sw?.count)
                    ? 'N/A'
                    : `${formatNumber(
                        dataStatistics?.filterRevenue?.sw?.count,
                        '.',
                      )}`}
                </div>
              </div>
            </Col>
            <Col xs={24} md={24} lg={isSaleMng ? 6 : 8}>
              <div className="box-item-data">
                <div className="text-title-data">
                  {translations?.['b2b.txt.totalSunHolidayRevenue']}
                </div>
                <div className="text-num-data">
                  {isLoadingStatistics
                    ? translations?.['b2b.txt.loadingData']
                    : _.isNil(dataStatistics?.filterRevenue?.holiday?.revenue)
                    ? 'N/A'
                    : `${formatNumber(
                        dataStatistics?.filterRevenue?.holiday?.revenue,
                        '.',
                      )}đ`}
                </div>
                <div className="text-title-data">
                  {translations?.['b2b.txt.totalOrders']}
                </div>
                <div className="text-num-data">
                  {isLoadingStatistics
                    ? translations?.['b2b.txt.loadingData']
                    : _.isNil(dataStatistics?.filterRevenue?.holiday?.count)
                    ? 'N/A'
                    : `${formatNumber(
                        dataStatistics?.filterRevenue?.holiday?.count,
                        '.',
                      )}`}
                </div>
              </div>
            </Col>
            {isSaleMng && (
              <Col xs={24} md={24} lg={6}>
                <div className="box-item-data">
                  <div className="text-title-data">
                    {translations?.['b2b.txt.agent-dept'] ?? ''}
                  </div>
                  <div className="text-num-data">
                    {isLoadingStatistics
                      ? translations?.['b2b.txt.loadingData']
                      : _.isNil(dataStatistics?.balanceInfo?.totalAmount)
                      ? 'N/A'
                      : `${formatNumber(
                          dataStatistics?.balanceInfo?.totalAmount,
                          '.',
                        )}đ`}
                  </div>
                  <div className="text-title-data">
                    {translations?.['b2b.txt.agent-deposit-balance']}
                  </div>
                  <div className="text-num-data">
                    {isLoadingStatistics
                      ? translations?.['b2b.txt.loadingData']
                      : _.isNil(dataStatistics?.balanceInfo?.amount)
                      ? 'N/A'
                      : `${formatNumber(
                          dataStatistics?.balanceInfo?.amount,
                          '.',
                        )}đ`}
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </div>
        {/* revenue report*/}
        <div className="box-revenue-report">
          <StyledStack
            justifyContent={'space-between'}
            style={{ marginBottom: 20 }}
          >
            <ReportCardTitle>
              <div className="sub-title">
                {translations?.['b2b.txt.revenueReport']}
              </div>
              <div className="report-card-note">
                {translations?.['b2b.txt.successfulTicketNote'] ?? ''}
              </div>
            </ReportCardTitle>
            <StyledSelect
              suffixIcon={<ArrowDownIcon />}
              value={yearFilter}
              onChange={onChangeYearFilter}
              options={dataFilterRevenue}
            />
          </StyledStack>
          <LoadingContainer loading={isLoadingRevenueReport}>
            {!isLoadingRevenueReport && (
              <RevenueReportChart
                translations={translations}
                data={revenueResult?.charts?.revenueReport || []}
                isLoading={isLoadingRevenueReport}
              />
            )}
          </LoadingContainer>
        </div>
        {/* báo cáo 1 & 2 */}
        <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
          <Col xs={24} lg={12} style={{ width: '100%' }}>
            <ParkRevenueReport translations={translations} />
          </Col>
          <Col xs={24} lg={12} style={{ width: '100%' }}>
            <TicketTypeRevenueReport translations={translations} />
          </Col>
        </Row>
        {/* báo cáo 3 */}
        <div style={{ marginTop: 20 }}>
          <TopProductReport translations={translations} />
        </div>
        {/* báo cáo 4: chỉ hiển thị với role lãnh đạo */}
        {isSaleMng && (
          <div style={{ marginTop: 20 }}>
            <TopStaffReport translations={translations} />
          </div>
        )}
        {/* pie chart */}
        {/* <div className="row g-3">
          <div className="col-12 col-lg-6 ">
            <div className="box-revenue-ratio">
              <StyledStack
                justifyContent={'space-between'}
                style={{ marginBottom: 20 }}
              >
                <div className="sub-title">
                  {translations?.['b2b.txt.revenueRatioByPark']}
                </div>
                <RangeDatePickerContainer>
                  <RangeDatePickerCustom
                    placeholder={
                      translations ? translations['b2b.txt.ticket-expried'] : ''
                    }
                    startDateInit={startDatePark}
                    endDateInit={endDatePark}
                    onChange={([start, end]) => {
                      if (!start || !end) return;
                      setStartDatePark(start);
                      setEndDatePark(end);
                    }}
                    minDate={null}
                    onCalendarClose={handleChangeTimePark}
                  />
                </RangeDatePickerContainer>
              </StyledStack>
              <LoadingContainer loading={false}>
                <RevenuePieChart translations={translations} />
              </LoadingContainer>
            </div>
          </div>
          <div className="col-12 col-lg-6 ">
            <div className="box-revenue-ratio">
              <StyledStack
                justifyContent={'space-between'}
                style={{ marginBottom: 20 }}
              >
                <div className="sub-title">
                  {translations?.['b2b.txt.revenueRatioByTicketGroup']}
                </div>
                <RangeDatePickerContainer>
                  <RangeDatePickerCustom
                    placeholder={
                      translations ? translations['b2b.txt.ticket-expried'] : ''
                    }
                    startDateInit={startDateTicket}
                    endDateInit={endDateTicket}
                    onChange={([start, end]) => {
                      if (!start || !end) return;
                      setStartDateTicket(start);
                      setEndDateTicket(end);
                    }}
                    minDate={null}
                    onCalendarClose={handleChangeTimeTicket}
                  />
                </RangeDatePickerContainer>
              </StyledStack>
              <LoadingContainer loading={false}>
                <RevenuePieChart translations={translations} />
              </LoadingContainer>
            </div>
          </div>
        </div> */}
      </HomePageWrapper>
    </ContainerFluid>
  );
};
export const RangeDatePickerContainer = styled.div`
  background-color: #fff;
  border-radius: 5px;
`;
const ButtonSeeAll = styled.button`
  margin-left: auto;
  color: var(--color-4);
  font-size: 14px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid var(--color-4);
  padding: 0;
  min-width: fit-content;
  i {
    margin-left: 6px;
  }
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    color: var(--color-8);
    border-bottom: 1px solid var(--color-8);
  }
`;
